import { DSButton } from '@/components/ds/Button/Button'
import { DSFormErrorText } from '@/components/ds/FormErrorText/FormErrorText'
import { DSInput } from '@/components/ds/Input/Input'
import { DSSpacer } from '@/components/ds/Spacer/Spacer'
import { trackCtaClick } from '@/lib/gtm/gtmV2'
import { useFormikContext } from 'formik'
import { PressEvent } from 'react-aria-components'
import { DSLinkText } from '@/components/ds/LinkText/LinkText'

const handleOnPress = (e: PressEvent) => {
  // TODO: Check with Analytics
  // trackCtaClick('checkout', 'Log in with ZOE')
}

interface EmailFormValues {
  email: string
}

export const EmailFormContent = () => {
  const { values, errors, isSubmitting, isValid } = useFormikContext<EmailFormValues>()

  return (
    <>
      <DSInput name="email" type="email" placeholder="Email" autoComplete="username" />
      <DSSpacer size={12} direction="vertical" />

      {errors.email ? (
        <>
          <DSFormErrorText>
            Invalid email. Please try again or contact us at{' '}
            <DSLinkText href="mailto:hello@joinzoe.com" colourScheme="inherit" target="_blank" rel="noreferrer">
              hello@joinzoe.com
            </DSLinkText>
          </DSFormErrorText>
          <DSSpacer size={12} direction="vertical" />
        </>
      ) : null}

      <DSButton
        onPress={handleOnPress}
        type="submit"
        isDisabled={!values.email || !isValid || isSubmitting}
        variant="primary"
        colourScheme="default"
        size="large"
        width="full"
        dangerouslySet__rounded
      >
        Send me a reset link
      </DSButton>
    </>
  )
}
